import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { YouthPhotoConfig } from './youth-photo-url.config';

@Injectable({
  providedIn: 'root'
})
export class YouthPhotoService {

  constructor(private httpService: HttpService ) { 
    //Do Nothing
  }

  uploadKey(objparams: any) {
    return this.httpService.post(YouthPhotoConfig.EndPoint.UploadKey, objparams);
  }

  addPhoto(data: any){
    return this.httpService.post(YouthPhotoConfig.EndPoint.addYouthPhoto, data);
  }

  getYouthPhoto(youthid){
    return this.httpService.get(YouthPhotoConfig.EndPoint.getYouthPhoto.replace('{youthid}', youthid));
  }

  deleteYouthPhoto(youthid){
    return this.httpService.patch(YouthPhotoConfig.EndPoint.removeYouthPhoto.replace('{youthid}', youthid));
  }

  getByPhotoId(photoid){
    return this.httpService.get(YouthPhotoConfig.EndPoint.getbyPhotoId.replace('{photoid}', photoid));
  }

  updateYouthPhoto(data){
    return this.httpService.put(YouthPhotoConfig.EndPoint.updateYouthPhoto, data);
  }

  getPhysicalDescription(youthid){
    return this.httpService.get(YouthPhotoConfig.EndPoint.getPhysicalDescription.replace('{youthid}', youthid));
  }

  getPhysicalMarkDescription(code){
    return this.httpService.get(YouthPhotoConfig.EndPoint.getPhysicalLookUp + '?type=' + code);
  }

  getActivePage(tabPageId: any, permission?: boolean, action?: string) {
    return this.httpService.get(
      `${YouthPhotoConfig.EndPoint.getActivePage.replace('{id}', tabPageId)}${permission
        ? '?applyPermissions=true' : ''}${permission && action === 'add'
          ? '&action=add' : ''}${permission && action === 'edit'
            ? '&action=edit' : ''}${permission && action === 'view'
              ? '&action=view' : ''}`
    );
  }
}
